import React from 'react';
import { Paragraph, Button } from '@contentful/forma-36-react-components';
import { FieldExtensionSDK } from 'contentful-ui-extensions-sdk';
import { CliplisterStored, CliplisterResult } from '../typings';

interface FieldProps {
  sdk: FieldExtensionSDK;
}

interface Props {
  sdk: FieldExtensionSDK;
}

interface State {
  value: CliplisterStored;
}

export default class Field extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      value: props.sdk.field.getValue() || null,
    };
  }

  detachExternalChangeHandler: Function | null = null;

  componentDidMount() {
    this.props.sdk.window.startAutoResizer();

    // Handler for external field value changes (e.g. when multiple authors are working on the same entry).
    this.detachExternalChangeHandler = this.props.sdk.field.onValueChanged(this.onExternalChange);
  }

  componentWillUnmount() {
    if (this.detachExternalChangeHandler) {
      this.detachExternalChangeHandler();
    }
  }

  generateTemplateUrl(photo: CliplisterResult){
    let linkAppend = "?";

    photo.templateJson.variables.map((variable)=>{
      if("value" in variable && variable.value != ""){
        // @ts-ignore
        linkAppend = linkAppend+variable.name +"="+encodeURIComponent(variable.value)+"&"
      }
    }) 

    //console.log("linkAppend", linkAppend);
    //linkAppend = linkAppend + "x="+photo.templateJson.defaultSettings.width;
    linkAppend = linkAppend + "x=370";
    console.log("TEMP:", linkAppend);
    return "https://template.mycliplister.com/isaclte/172918/c3/-/-/"+photo.uuid+linkAppend;
  }


  onExternalChange = (selectedPhoto: CliplisterResult) => {

    /*var photos = this.state.value;
    console.log("EXTERNAL CHANGE: ")
    photos?.assets.push(selectedPhoto);*/
    //this.setState({ value: photos });
  };

  openSearch = async () => {
    const selectedPhoto: CliplisterResult | null = await this.props.sdk.dialogs.openCurrentApp({
      title: 'Select a asset',
      minHeight: 800,
      width: 'large'
    });

    if (selectedPhoto) { 
      var photos = this.state.value;
      //var finalResult: CliplisterResult = {title: selectedPhoto.title, uuid: selectedPhoto.uuid, fileName: selectedPhoto.fileName, fileType: selectedPhoto.fileType, fileExt: selectedPhoto.fileExt, uniqueId: selectedPhoto.uniqueId};
      var finalResult: CliplisterResult = selectedPhoto;

      if(photos == null){
        console.log("PHOTOS NULL", photos);
        var empty: CliplisterStored = {assets:[]};
        empty.assets.push(finalResult);
        photos = empty;
      }else{
        photos.assets.push(finalResult);
      }
      this.props.sdk.field.setValue(photos);
      this.setState({ value: photos });
      console.log("NOW:", photos);
    }
  };

  removeAsset = (photo: CliplisterResult, position: number) =>{
    console.log(photo.uuid);
    var filtered = this.state.value;
    filtered.assets = filtered.assets.filter(function(el, pos) { return pos != position }); 
    console.log(filtered);
    this.props.sdk.field.setValue(filtered);
    this.setState({ value: filtered });
  }

  render() {
    const { value } = this.state;

    //@ts-ignore
    const parameters: AppInstallationParameters = this.props.sdk.parameters.installation;
    console.log("RENDER:", value)
    var position = 0;
    return (
      <div>
        <Button className="cliplisterButton" onClick={this.openSearch}>+ Add Cliplister Asset</Button>
        <div>
          {value != undefined && value.assets.map((photo, pos)=> {
            var backgroundImage = {backgroundImage: `url(${parameters.cliplisterSourceUrl+photo.uuid}?x=400)`}
            console.log(photo.kind);
            if(photo.kind == "template"){
              backgroundImage = {backgroundImage: "url("+this.generateTemplateUrl(photo)+")"}
            }else if(photo.fileExt == "mp3"){
              backgroundImage = {backgroundImage: `url()`};
            }
            return(
              <div style={backgroundImage} title={photo.title} onClick={() => this.removeAsset(photo, pos)} className="cliplisterImagePreview" >
                {photo.fileType == "Video" &&
                  <svg className="Illustration__Illustration___1R5Px cliplisterVideoPreview" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"><path d="M20.5 23.5h-17V.5h11l6 6z"></path><path d="M14.5.5v6h6M8.5 8.5l8 5-8 5z"></path></g></svg>
                }
                {photo.kind == "3Dasset" &&
                  <svg data-test-id="cf-ui-asset-icon" className="Illustration__Illustration___1R5Px cliplisterVideoPreview" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"><g fill="none" stroke="#000"><path d="M20.688 23.492h-17v-23h11l6 6v17z"></path><path d="M14.688.492v6h6M14.688 10.492l4 4-4 4M9.688 10.492l-4 4 4 4"></path></g></svg>
                } 
                {photo.fileExt == "mp3" &&
                  <svg data-test-id="cf-ui-asset-icon" className="Illustration__Illustration___1R5Px cliplisterVideoPreview" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"><path d="M9 12.5H7.25a.75.75 0 0 0-.75.75v1.5c0 .414.336.75.75.75H9l3.5 3.5V9L9 12.5zM16 11c.834.688 1.5 1.835 1.5 3 0 1.163-.669 2.312-1.5 3M14 12.25c.562.409 1 1.001 1 1.75 0 .749-.438 1.341-1 1.75"></path><path d="M21.5 23.5h-19V.5h13l6 6z"></path><path d="M15.5.5v6h6"></path></g></svg>
                } 
                <div className="cliplisterAssetTitle">
                  {photo.title}
                </div>
                <div className="cliplisterRemoveOverlayer">
                  <p>
                    Click to remove
                  </p>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    );
  };
}